/**
 * aiCreators — minimal AI-creator registry (Zoe Live Embed V1).
 *
 * V1 scope: one seed creator (Zoe) on one provider (Trulience). This is the
 * smallest reusable shape — adding a second creator = one more object here,
 * no component change. Generalizes to the full AICreator entity later
 * (see docs/zoe/ICG-AI-CREATOR-PLATFORM-V1.md).
 *
 * NOTE: `avatarId` is a PUBLIC Trulience avatar id (visible in the public
 * embed URL) — it is NOT a secret and is safe to ship in the bundle.
 */

// Feature flag — OFF unless explicitly enabled. Unset => production is byte-identical.
export const ZOE_LIVE_ENABLED =
  (process.env.REACT_APP_ENABLE_ZOE_LIVE || "").toLowerCase() === "true";

export const AI_CREATORS = {
  zoe: {
    creator_id: "zoe",
    slug: "zoe-harlow",
    display_name: "Zoe Harlow",
    provider: "trulience",
    // Public avatar id from https://www.trulience.com/avatar/9101879118775340193
    avatarId: "9101879118775340193",
    thumbnail: "/zoe-harlow.webp",
    // Passed through to the Trulience embed URL builder:
    connect: true, // auto-connect on load (desktop); on iOS we require the tap that opened the modal
    msgOnConnect: "Hi, I'm Zoe 😊",
    // Match ICG dark theme inside the Trulience chat UI:
    chatScreenBGColor: "0d0d1a",
  },
};

export function getCreator(id) {
  return AI_CREATORS[id] || null;
}
